
import { Vessel, VesselAuction, ExemptionVessel, IVesselQuotaData, IQuotaTransaction, RecreationalVessel, RecreationalVesselFilter, IVesselDocument } from "interface/vessel";
import { AxiosApi } from "./index";
import { RegisterRecreationalForm } from "interface/recreationalFishers";
import { ApiResponse } from "interface/response";


export interface VesselDocumentFilterOptions {
	vesselId?: string;
	vesselName?: string;
    documentId?: string;
	vesselRegistrationId?: string;
    includeDeleted?: number;
    includeContent?: number;
}

export async function getAllVessel({ text, resKto, source, date, rn, id, allowCallSign = false }: { text: string, date?: Date, allowCallSign?: boolean, source?: string, resKto?: number, id?: number, rn?: string }) {
    const apiUri = "Vessel/GetAll"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, resKto, source, date, id, allowCallSign, rn
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselFilter(text: string, returnAll = false) {
    const apiUri = "Vessel/GetAll"
    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, returnAll
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getUserSettingVesselssFilterApi() {
    const apiUri = "administration/UserSettingVessels"

    try {
        const buyer = await AxiosApi.get<Vessel[]>(apiUri, {})
        return buyer.data
    } catch (error: any) {
        throw error
    }
}

export async function getRegistrationVessels(text: string, returnAll = false) {
    const apiUri = "vessel/registration-vessels"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {
            params: {
                text, returnAll
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getUserVessels() {
    const apiUri = "Vessel/GetUserVessel"

    try {
        const vessel = await AxiosApi.get<Vessel[]>(apiUri, {

        })
        return vessel.data
    } catch (error) {
        throw error
    }
}
export async function getAuctionVesselNO(text: string) {
    const apiUri = "Vessel/auctionedVessels"

    try {
        const vessel = await AxiosApi.get<VesselAuction[]>(apiUri, {
            params: {
                text,
                source: "rn"

            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}
export async function getAuctionVesselByName(text: string) {
    const apiUri = "Vessel/auctionedVessels"

    try {
        const vessel = await AxiosApi.get<VesselAuction[]>(apiUri, {
            params: {
                text,
                source: "nm"
            }
        })

        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselByIdApi(vesselId: string) {
    const apiUri = "Vessel/Get"

    try {
        const vessel = await AxiosApi.get<Vessel>(apiUri, {
            params: {
                vesselId
            }
        })
        return vessel.data
    } catch (error : any) {
        throw error
    }
}
export async function getVesselDetailApi(vesselId: string,regNo: string, vesselName: string) {
    const apiUri = "Vessel/Detail"

    try {
        const vessel = await AxiosApi.get<Vessel>(apiUri, {
            params: {
                vesselId,
                regNo,
                vesselName
            }
        })
        return vessel.data
    } catch (error : any) {
        throw error
    }
}


export async function getExemptionVesselApi(vesselId: string, lastCatchDate: Date) {
    const apiUri = "Vessel/ExemptionVessels"

    try {
        const vessel = await AxiosApi.get<ExemptionVessel[]>(apiUri, {
            params: {
                vesselId,
                lastCatchDate
            }
        })
        return vessel.data
    } catch (error) {
        throw error
    }
}

export async function getVesselQuotasApi(vesselId: string, vesselRegNo: string, year: number) {
    const apiUri = "Vessel/Quotas"

    try {
        const response = await AxiosApi.get<IVesselQuotaData[]>(apiUri, {
            params: { vesselId, vesselRegNo, year }
        })

        return response.data
    } catch (error) {
        throw error
    }
}

export async function getQuotaTransactionApi(
    accountNumber: string,
    validFrom: string,
    validTo: string,
    source: string,
) {
    const apiUri = "Vessel/QuotaTransactions"

    try {
        const response = await AxiosApi.get<IQuotaTransaction[]>(apiUri, {
            params: { accountNumber, validFrom, validTo, source }
        })
        return response.data
    } catch (error) {
        throw error
    }
}

export async function recreationalVesselRegistrationApi(
    data:RegisterRecreationalForm
) {
    const apiUri = "Vessel/RecreationalVesselRegistration"

    try {
		const response = await AxiosApi.post<ApiResponse<boolean>>(
			apiUri,
			data,
		)
        return response.data
    } catch (error) {
        throw error
    }
}

export async function getRecreationalVesselsApi(
    {
        ledgerAccount,
        skip = 0,
        take = 100,
        registrationNumber,
        vesselId,
        callSign,
        description,
        status,
        lenghtFrom,
        lenghtTo,
    }: RecreationalVesselFilter,
) {
    const apiUri = "Vessel/GetRecreationalVessel"

    try {
        const response = await AxiosApi.get<ApiResponse<RecreationalVessel[]>>(apiUri, {
            params: {
                ledgerAccount,
                skip,
                take,
                registrationNumber,
                vesselId,
                callSign,
                description,
                status,
                lenghtFrom,
                lenghtTo,
            },
        })
        return response.data
    } catch (error) {
        throw error
    }
}



export async function getVesselDocumentsApi(filter: VesselDocumentFilterOptions ) {
    const response = await AxiosApi.get<IVesselDocument[]>("Vessel/GetVesselDocuments", {
        params: { vesselId: filter.vesselId, vesselRegistrationId: filter.vesselRegistrationId,
            documentId: filter.documentId || null, includeDeleted: filter.includeDeleted || 0, includeContent: filter.includeContent || 0 },
    });
    return response.data ?? [];
}

export async function uploadVesselDocumentApi(file: File, filter: VesselDocumentFilterOptions, description = "") {
    const body = new FormData();
    body.append("file", file);
    return (await AxiosApi.post<IVesselDocument>("Vessel/UploadVesselDocument", body, {
        params: { vesselId: filter.vesselId, vesselRegistrationId: filter.vesselRegistrationId,
            filename: file.name, description },
    })).data;
}

export async function deleteVesselDocumentApi(data: VesselDocumentFilterOptions & { fileName: string }) {
    await AxiosApi.delete("Vessel/VesselDocument", {
        params: { vesselId: data.vesselId, vesselRegistrationId: data.vesselRegistrationId, documentId: data.documentId, fileName: data.fileName ?? "" },
    });
}
